import styled from "@emotion/styled";
import { ThemeKey } from "@smartsheet/design-tokens";
import { datePickerTheme } from "./datePickerTheme";

export interface DatePickerDayBoxProps {
    themeMode: ThemeKey;
}

// A single box in the calendar grid.
// contains shared styles between the week headers and the days.
export const DatePickerDayBox = styled("div")<DatePickerDayBoxProps>`
    box-sizing: border-box;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    background-color: transparent;
    transition: background-color ${({ themeMode }) => datePickerTheme.dayTransitionDuration(themeMode)} ease-out;

    // For Ursa, we need to add a bit of extra spacing between the days (but not outside the
    // left/right edges). We can't use css grid column-gap because the DateRangePickerDialog needs
    // contiguous boxes to apply the highlight between the start/end dates.
    &:not(:nth-of-type(7n + 1)) {
        padding-left: ${({ themeMode }) => datePickerTheme.dayInnerPadding(themeMode)};
    }
    &:not(:nth-of-type(7n)) {
        padding-right: ${({ themeMode }) => datePickerTheme.dayInnerPadding(themeMode)};
    }
`;
